import { render, staticRenderFns } from "./CompilationsList.vue?vue&type=template&id=34447504&scoped=true&"
import script from "./CompilationsList.vue?vue&type=script&lang=js&"
export * from "./CompilationsList.vue?vue&type=script&lang=js&"
import style0 from "./CompilationsList.vue?vue&type=style&index=0&id=34447504&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34447504",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CompilationItem: require('/home/bitrix/frontend/components/compilations/CompilationItem.vue').default})
